import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { GetApp as GetAppBase } from '@mui/icons-material'

export const Root = styled('div')`
  width: 100%;
`

export const Action = styled('div')`
  display: flex;
  justify-content: flex-end;

  ${props => props.theme.breakpoints.down('sm')} {
    justify-content: center;
  }
`

export const ActionItem = styled(({ disabled, ...props }) => <div {...props} />)`
  align-items: center;
  color: ${props => (props.disabled ? props.theme.palette.brand.disableButton : props.theme.palette.brand.black1)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1.13px;
  line-height: normal;
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  text-transform: uppercase;
  user-select: none;

  &:hover span {
    text-decoration: underline;
  }
`

export const ActionCircle = styled(({ disabled, ...props }) => <div {...props} />)`
  align-items: center;
  border: 1px solid
    ${props => (props.disabled ? props.theme.palette.brand.disableButton : props.theme.palette.brand.black1)};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0 6px 0 0;
`

export const ActionText = styled('span')``

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const DownloadIcon = styled(GetAppBase)`
  &.MuiSvgIcon-root {
    font-size: 1.2rem;
    height: 14px;
    padding: 2px;
    width: 14px;
  }
`

export const ExclamationIcon = styled('div')`
  height: 12px;
  padding: 1px;
  outline: none;
  width: 12px;

  &::before {
    color: ${props => props.theme.palette.brand.white};
    content: '¡';
    display: block;
    font-size: 10px;
    line-height: 9px;
    margin-left: 0.5px;
    text-align: center;
    width: 100%;
  }
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridContainerFooter = styled(GridContainer)`
  &.MuiGrid-container {
    background-color: ${props => props.theme.palette.brand.white};
    border-radius: 4px;
    box-shadow: 0 4px 8px 0 ${props => props.theme.palette.gray[85]};
    box-sizing: border-box;
    width: 100%;
  }
`

export const GridItem = styled(({ textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    text-align: ${props => props.textAlign};
  }
`

export const Info = styled(({ justifyContent, ...props }) => <div {...props} />)`
  align-items: center;
  color: ${props => props.theme.palette.brand.black1};
  cursor: initial;
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1.13px;
  line-height: normal;
  text-transform: uppercase;
  user-select: none;

  ${props => props.theme.breakpoints.down('sm')} {
    justify-content: center;
  }
`

export const InfoCircle = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.black1};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0 0 0 6px;
`

export const InfoText = styled('span')``

export const Link = styled(LinkBase)`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const TextDownload = styled('span')`
  letter-spacing: 1.15px;
  margin-left: 16px;
`
